import { isFeatureEnabled, FEATURES } from '~src/features';

/**
 * Checks if the settings button should be displayed based on feature flags
 * and other conditions
 * @returns {Promise<boolean>} True if settings should be displayed
 */
async function shouldDisplaySettings() {
  // Check if spell check feature is enabled
  const spellCheckFeatureEnabled = await isFeatureEnabled(FEATURES.SPELLCHECK);

  // For now, only show settings if spell check is enabled
  // In the future, additional conditions can be added here
  return spellCheckFeatureEnabled;
}

/**
 * Conditionally displays the settings button in the sidebar
 */
export async function displaySettingsButton() {
  const settingsButton = document.getElementById('btn-sidebar-settings');

  if (!settingsButton) {
    console.warn('Settings button not found in DOM');
    return;
  }

  try {
    const shouldDisplay = await shouldDisplaySettings();

    if (shouldDisplay) {
      settingsButton.classList.remove('d-none');
    } else {
      settingsButton.classList.add('d-none');
    }
  } catch (error) {
    console.error('Error checking if settings should be displayed:', error);
    // Hide by default on error
    settingsButton.classList.add('d-none');
  }
}
